"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowRight, CircleCheck as CheckCircle2, PhoneCall, ShieldCheck } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function CallToAction() {
  const shouldReduceMotion = useReducedMotion();
  const benefits = ["Apoio técnico especializado em engenharia de pulverização", "Representante exclusivo Spraying Systems Co. em Portugal", "Soluções à medida para máxima eficiência e poupança"];
  return <section id="calltoaction" data-nav="light" className="relative overflow-hidden bg-background py-20 lg:py-28">
      <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1
      } : {
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.5,
        ease: "easeOut"
      }} className="relative overflow-hidden rounded-3xl bg-primary px-6 py-12 text-primary-foreground shadow-2xl sm:px-12 lg:px-16 lg:py-16">
          {/* Subtle industrial grid background effect */}
          <div className="pointer-events-none absolute inset-0 opacity-10" aria-hidden="true">
            <div className="h-full w-full bg-[radial-gradient(ellipse_at_center,var(--color-primary-foreground)_1px,transparent_1px)] [background-size:24px_24px]" />
          </div>

          <div className="relative z-10 grid grid-cols-1 items-center gap-10 lg:grid-cols-12 lg:gap-12">
            <div className="lg:col-span-7">
              <div className="inline-flex items-center gap-2 rounded-full bg-primary-foreground/10 px-3.5 py-1.5 text-xs font-medium text-primary-foreground ring-1 ring-primary-foreground/20">
                <ShieldCheck className="size-4" />
                <span>Especialistas em Pulverização Industrial</span>
              </div>

              <h2 className="mt-4 text-3xl font-semibold tracking-tight text-primary-foreground sm:text-4xl lg:text-5xl font-default">
                Otimize os seus processos de pulverização.
              </h2>

              <p className="mt-4 max-w-xl text-base text-primary-foreground/80 sm:text-lg">
                Fale com a nossa equipa de engenharia para encontrar os bicos, lanças e sistemas automatizados ideais para a sua indústria.
              </p>

              <ul className="mt-6 space-y-2.5">
                {benefits.map((benefit, index) => <li key={index} data-index={index} className="flex items-center gap-2.5 text-sm text-primary-foreground/90 sm:text-base">
                    <CheckCircle2 className="size-4 shrink-0 text-secondary" />
                    <span>{benefit}</span>
                  </li>)}
              </ul>
            </div>

            <div className="flex flex-col items-start gap-4 sm:flex-row sm:items-center lg:col-span-5 lg:flex-col lg:items-end lg:justify-center">
              <Button asChild size="lg" className="w-full bg-secondary text-secondary-foreground shadow-md transition-[background-color,transform,box-shadow] duration-200 hover:bg-secondary/90 sm:w-auto lg:w-full">
                <Link to="/ContactsPage" className="flex items-center justify-center gap-2 text-base font-semibold py-6">
                  <span>Solicite um orçamento</span>
                  <ArrowRight className="size-5" />
                </Link>
              </Button>

              <Button asChild variant="outline" size="lg" className="w-full border-primary-foreground/30 bg-primary-foreground/10 text-primary-foreground shadow-xs transition-[background-color,border-color] duration-200 hover:bg-primary-foreground/20 hover:text-primary-foreground sm:w-auto lg:w-full">
                <Link to="/ContactsPage" className="flex items-center justify-center gap-2 text-sm font-medium py-6">
                  <PhoneCall className="size-4" />
                  <span>Falar com engenheiro técnico</span>
                </Link>
              </Button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}